import * as _ from 'underscore';

import { IDataSource } from '../../datasource/ServerApi/types/IDataSource';
import { FlowOutputStepInfo } from '../models/FlowOutputStepInfo';
import { FlowOutputStep } from '../ServerApi/types/FlowOutputStep';
import { IDataConnection } from '../ServerApi/types/IDataConnection';
import { FlowRunSpecOutputStepParamsMap } from '../ServerApi/types/RunFlowTask';

type DataConnectionWithProjectId = IDataConnection & { projectId: string };

export module FlowOutputStepMapper {

  export function map(
    flowOutputSteps: ReadonlyArray<FlowOutputStep>,
    dataConnections: _.Dictionary<IDataConnection>,
    datasources: _.Dictionary<IDataSource>,
    flowRunSpecOutputStepParamsMap: FlowRunSpecOutputStepParamsMap
  ): FlowOutputStepInfo[] {

    return _.map(flowOutputSteps, (fos: FlowOutputStep) => {
      const dataConnection = dataConnections[fos.connectionId];
      return {
        dataConnection: dataConnection,
        flowId: fos.flowId,
        id: fos.id,
        name: fos.name,
        datasourceName: dataConnection.datasourceId && datasources[dataConnection.datasourceId].name || '',
        datasourceId: fos.datasourceId,
        dataRoleId: fos.dataRoleId,
        isIncremental: getIsIncremental(flowRunSpecOutputStepParamsMap, fos.id),
        isIncrementalEnabled: fos.isIncrementalEnabled,
        isIncrementalDefault: fos.isIncrementalDefault,
        outputOperationType: fos.outputOperationType,
        incrementalOutputOperationType: fos.incrementalOutputOperationType,
        relevantParameters: fos.relevantParameters,
      };
    });
  }

  export function mapForRunFlowTask(
    flowOutputSteps: FlowOutputStep[],
    dataConnections: _.Dictionary<IDataConnection>,
    flowRunSpecOutputStepParamsMap: FlowRunSpecOutputStepParamsMap,
    isRunAllIncremental: boolean,
    datasources?: _.Dictionary<IDataSource>,
  ): FlowOutputStepInfo[] {

    return _.map(flowOutputSteps, (fos: FlowOutputStep) => {
      const dataConnection = dataConnections[fos.connectionId];
      const datasource = datasources !== undefined  ? datasources[dataConnection.datasourceId] : undefined;
      const datasourceName = datasource ? datasource.name || '' : undefined;
      return {
        dataConnection: dataConnection,
        flowId: fos.flowId,
        id: fos.id,
        name: fos.name,
        datasourceName: datasourceName,
        datasourceId: fos.datasourceId,
        dataRoleId: fos.dataRoleId,
        isIncremental: isRunAllIncremental != null ? isRunAllIncremental : getIsIncremental(flowRunSpecOutputStepParamsMap, fos.id),
        isIncrementalEnabled: fos.isIncrementalEnabled,
        isIncrementalDefault: fos.isIncrementalDefault,
        outputOperationType: fos.outputOperationType,
        incrementalOutputOperationType: fos.incrementalOutputOperationType,
        relevantParameters: fos.relevantParameters,
      };
    });
  }

  function getIsIncremental(flowRunSpecOutputStepParamsMap: FlowRunSpecOutputStepParamsMap, id: string) {
    if (!flowRunSpecOutputStepParamsMap){
      return null;
    }

    const param = flowRunSpecOutputStepParamsMap[parseInt(id, 10)];

    return param ? param.isIncremental : null;
  }
}
